/**
 * Позиции карточек How development happens (десктоп, бесконечный цикл).
 */

export const PROCESS_POS = {
    left: "translateX(calc((100vw - 999px) / 4))",
    mid: "translateX(calc((100vw - 999px) / 2 + 333px))",
    right: "translateX(calc((300vw - 333px) / 4))",
    offLeft: "translateX(-333px)",
    offRight: "translateX(100vw)",
};

export function getProcessSlot(index, active, count) {
    return (index - active + count) % count;
}

export function getProcessTransform(index, active, count) {
    const slot = getProcessSlot(index, active, count);
    if (slot === 0) return PROCESS_POS.left;
    if (slot === 1) return PROCESS_POS.mid;
    if (slot === 2) return PROCESS_POS.right;
    if (slot === count - 1) return PROCESS_POS.offLeft;
    return PROCESS_POS.offRight;
}

function isParkedLeft(slot, count) {
    return slot === count - 1;
}

function isParkedRight(slot, count) {
    return slot >= 3 && slot < count - 1;
}

export function getInstantMoveCards(from, to, count) {
    const cards = new Set();
    const step = (to - from + count) % count;
    const adjacent = step === 1 || step === count - 1;
    for (let i = 0; i < count; i += 1) {
        const prevSlot = getProcessSlot(i, from, count);
        const nextSlot = getProcessSlot(i, to, count);
        if (!adjacent) {
            cards.add(i);
            continue;
        }
        if (
            (isParkedLeft(prevSlot, count) && isParkedRight(nextSlot, count)) ||
            (isParkedRight(prevSlot, count) && isParkedLeft(nextSlot, count))
        ) {
            cards.add(i);
        }
    }
    return cards;
}

export function getProcessArrowDir(index, active, count) {
    return getProcessSlot(index, active, count) === 0 ? "prev" : "next";
}

// utils/processCarousel.js
